export default __webpack_public_path__ + "static/media/iconoTelefono.5a732ead.png";